<template>
  <section class="mbComSelectSc" v-if="comList.length > 1">
    <div class="mbComSelect">
      <span @click="changeCom">{{ iconText }}</span>
    </div>
    <van-dialog
      v-model="show"
      title="切换厂区"
      :show-cancel-button="false"
      @confirm="confirm"
    >
      <van-radio-group v-model="radio">
        <van-cell-group v-for="(item, index) in comList" :key="index">
          <van-cell
            :title="item.com_name"
            clickable
            @click="radio = item.com_id"
          >
            <template #right-icon>
              <van-radio :name="item.com_id" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      comList: [],
      comObj: null,
      iconText: "",
      show: false,
      radio: ""
    };
  },
  created() {
    this.$common
      .http({
        method: "get",
        // url: "/api/permission/list_com"
        url: "/api/permission/wxqy_list_com"
      })
      .then(res => {
        this.comList = [];
        if (res.data.data == undefined) {
          return;
        }
        res.data.data.forEach(element => {
          if (Number(element.is_main_com) == 0) {
            this.comList.push(element);
          }
          if (Number(element.com_is_current) == 1) {
            this.comObj = element;
            this.iconText = this.comObj.com_name.split("")[0];
            this.radio = this.comObj.com_id;
          }
        });
      });
  },
  methods: {
    confirm() {
      let orgComId = this.comObj.com_id;
      if (this.radio != this.comObj.com_id) {
        this.comList.forEach(item => {
          if (item.com_id == this.radio) {
            this.comObj = item;
          }
        });
        this.$common
          .http({
            // url: "/api/authorize/switch_com",
            url: "/api/authorize/qywx_switch_com",
            data: {
              com_id: this.comObj.com_id
            }
          })
          .then(
            () => {
              let noPowerReturnUrl = window.localStorage.getItem(
                "noPowerReturnUrl"
              );
              if (noPowerReturnUrl != null) {
                window.localStorage.removeItem("noPowerReturnUrl");
                window.location.href = noPowerReturnUrl;
              } else {
                window.location.reload();
                // this.$router.go(0);
              }
            },
            () => {
              this.radio = orgComId;
              this.comList.forEach(item => {
                if (item.com_id == orgComId) {
                  this.comObj = item;
                }
              });
            }
          );
      }
    },
    changeCom() {
      this.show = true;
    }
  }
};
</script>
<style lang="less">
.mbComSelectSc {
  .van-dialog__header {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .mbComSelect {
    position: fixed;
    bottom: 90px;
    right: 16px;
    > span {
      width: 60px;
      height: 60px;
      display: inline-block;
      line-height: 60px;
      font-size: 30px;
      text-align: center;
      font-weight: bold;
      border-radius: 30px;
      background: #00c8d2;
      color: #fff;
    }
  }
}
</style>
